import React from 'react';
import PropTypes from 'prop-types';
import Table from '../Table';
import InputsTableRow from './InputsTableRow';
import './styles.css';

function InputsTable(props) {
  const { caption, data, onChange, columns } = props;
  return (
    <Table>
      <caption style={{ display: 'none' }}>{caption}</caption>
      <Table.Header styleName="tableHeader">
        <Table.Row>
          { columns.map(({ header, name }) => <Table.HeaderCell key={name}>{header}</Table.HeaderCell>)}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        { data.map((sub) => (
          <InputsTableRow
            onChange={onChange}
            key={sub.id}
            columns={columns}
            data={sub}
            empty={sub.isAllEmpty}
          />
        ))}
      </Table.Body>
    </Table>
  );
}
InputsTable.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  caption: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.object),
};

InputsTable.defaultProps = {
  data: [],
  columns: [],
};

export default InputsTable;
